import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Tooltip from '@material-ui/core/Tooltip';
// common components
import CustomButton from './../../../common/Forms/CustomButton/CustomButton';
import CustomAvatar from './../../../common/Avatar/Avatar';
import Loader from './../.././../common/Loader/Loader';

const CourseList = ({ courseModule, manageCourse, courseList }) => {
	if (courseList && courseList.length > 0) {
		return (
			<div className='CourseList'>
				{courseList.map(item => (
					<div className="row card-view" key={item.id}>
						<div className="col col-lg card-heading first">
							<CustomAvatar name={item.name} />
							<div className="heading">
								<div className="title" onClick={() => courseModule(item.id)}>
									{item.name}{item.active==='N'&&(<span>&nbsp;-&nbsp;<span style={{color:"#f25c35"}} >Inactive</span></span>)}
							    </div>
								<Tooltip title={item.description} placement="bottom">
									<div className="desc">{item.description}</div>
								</Tooltip>
							</div>
						</div>
						<div className="col-12 col-lg details second">
							<div className="row card-detail">
								<div className="col">
									<div className="title"># of modules</div>
									<div className="value">{item.module_count}</div>
								</div>
								{/* <div className="col">
									<div className="title">created by</div>
									<div className="value">Jayaprakash</div>
								</div> */}
								<div className="col">
									<div className="title">created date</div>
									<div className="value">{moment(item.created_date).format('DD MMM YYYY')}</div>
								</div>
							</div>
						</div>
						<div className="col cardview-actions third">
							<div className="line" />
							{
								item.active==='Y'?
							<CustomButton
								name='clone'
								iconOnly
								iconName='clone'
								onClick={() => manageCourse(true, 'clone', item.id)}
							/>:
							<CustomButton
								name='activate'
								iconOnly
								iconName='activate'
								onClick={() => manageCourse(true, 'activate', item.id)}
							/>
							}
							<CustomButton
								name='edit'
								iconOnly
								iconName='edit'
								onClick={() => manageCourse(true, 'edit', item.id)}
							/>
							<CustomButton
								name='delete'
								iconOnly
								iconName='delete'
								onClick={() => manageCourse(true, 'delete', item.id)}
							/>
						</div>
					</div>
				))}
			</div>
		);
	}
	return (<Loader />);
}

CourseList.propTypes = {
	courseModule: PropTypes.func,
	manageCourse: PropTypes.func,
	courseList: PropTypes.instanceOf(Array)
};

CourseList.defaultProps = {
	courseModule: () => { },
	manageCourse: () => { },
	courseList: []
};

export default CourseList;



// WEBPACK FOOTER //
// ./components/Course/CourseList/CourseList.js